// extracted by mini-css-extract-plugin
export default {"highlightTm":"BDrugItem-module_highlightTm_c235955b"};